import types from '../../constants';

const initialState = {
  selectedUnits: [],
  selectedLocation: '',
  selectedPreviewLocation: ''
};

const DashboardReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.EXERCISE_RUN_UNITS_SELECT:
      return {
        ...state,
        selectedUnits: action.payload,
        selectedLocation: ''
      };
    case types.EXERCISE_RUN_LOCATION_SELECT:
      return {
        ...state,
        // selectedUnits: [],
        selectedLocation: action.payload
      };
    case types.EXERCISE_RUN_LOCATION_PREVIEW_SELECT:
      return {
        ...state,
        // selectedUnits: [],
        selectedPreviewLocation: action.payload
      };
    default:
      return state;
  }
};

export default DashboardReducers;
